<div class="spacer"></div>
<div class="container container-border container-size">
  <h2>{{ anwendungsname }}</h2>
</div>

<div class="spacer"></div>
<div class="container container-border container-size">
  <div class="row">
    <div class="col-md-12">
      <h4>Kurzbeschreibung Verfahren der Pseudonymisierung</h4>
    </div>
  </div>
  <mat-card>
  
      Im nachfolgenden werden die Schritte aufgeführt, welche durchgeführt
      werden, um eine CSV-Datei in die WEB-Anwendung "{{anwendungsname}}" einzulesen und zu
      pseudonymisieren.
    <br>
    <ol>
      <li>Auswahl der Zip-Datei/CSV-Datei durch den User in der Web-Anwendung.</li>
      <li>Innerhalb der Web-Anwendung wird im Browser, lokal auf dem Computer des Users, 
        eine Bereinigung der CSV-Datei durchgeführt. Danach sind nur noch die für
        die Klassifizierung notwendigen Daten enthalten.</li>
      <li>Der Betriebsname wird durch
        eine GUID (Globally Unique Identifier) ersetzt und dadurch pseudonymisiert.
        Welche GUID welchen Betrieb bezeichnet weiß nur der lokale Browser. Die
        GUID wird bei jeder Durchführung zufällig generiert und kann nicht
        vorhergesagt werden.</li>
        <li>Übertragen der Daten an den Webservice.</li>
        <li>Verarbeiten der Daten im Webservice.</li>
        <li>Ergebnisse werden an den Browser des
          Users vom Webservice gesendet.</li>
        <li>Die GUID in den Ergebnissen wird durch den
          originalen Betriebsnamen lokal im Browser ausgetauscht und dadurch die
          Pseudonymisierung rückgängig gemacht.</li>
        <li>Die Ergebnisse werden dem User als PDF oder als Ergebnisdarstellung in der Web-Anwendung zur Verfügung.</li>
        <li>Die bereinigten CSV-Altdaten, die vom Browser des Users an den Webservice übertragen wurden, werden sofort nach der Auswertung und dem Generieren der Ergebnisse in der Datenbank gelöscht.</li>
   </ol>
  </mat-card>

  <div class="spacer"></div>
  <mat-card>
    <div class="row">
      <div class="col-md-2">
        <button
          (click)="goBack()"
          mat-raised-button
          color="primary"
          class="custom-btn mt-3"
          type="button"
        >
          <fa-icon
            [icon]="faArrowLeft"
            class="ml-1 icon-vertical-align"
          ></fa-icon>
          Zurück
        </button>
      </div>
    </div>
  </mat-card>
</div>
<div class="spacer"></div>
